"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludeInvalidParams = void 0;
const omitValues_1 = require("@wix/cashier-common/dist/src/utils/omitValues");
const excludeInvalidParams = (params) => (0, omitValues_1.omitValues)(params, [null, undefined, '']);
exports.excludeInvalidParams = excludeInvalidParams;
//# sourceMappingURL=excludeInvalidParams.js.map